<template>
  <a-layout-content class="overflow-hidden">
    <div class="filter-panel">
      <a-row>
        <a-col :span="24" class="other-filter">
          <div class="mr-20">关键字:</div>
          <a-input class="mr-20" placeholder="关键字" v-model="keyword" style="width: 360px" />
          <a-button
            class="view-btn large"
            html-type="submit"
            @click="getUserListByDeptId"
            >搜索</a-button
          >
        </a-col>
      </a-row>
    </div>
    <a-divider></a-divider>
    <div class="flex-container filter-panel filter-panel2">
      <sub-title>数据列表 >> {{ selectedDeptName }}</sub-title>
      <ul class="handle-list" style="margin: -11px 0">
        <li class="handle-item" @click="showUser(null)">
          <a-icon type="form" class="u_svg_color" />
          <a href="javascript:;">新增</a>
        </li>
        <li class="handle-item" @click="delUserByIds">
          <a-icon type="delete" class="u_svg_color" />
          <a href="javascript:;">删除</a>
        </li>
        <li class="handle-item" @click="getUserListByDeptId">
          <a-icon type="reload" class="u_svg_color" />
          <a href="javascript:;">刷新</a>
        </li>
      </ul>
    </div>
    <a-divider></a-divider>
    <!-- 列表表格 -->
    <!-- 部门树 -->
    <div class="div-inline" style="width: 20%; height: 500px">
      <a-directory-tree
        v-if="depts.length"
        :treeData="depts"
        @select="onSelect"
        defaultExpandAll
      />
    </div>
    <!-- 部门树 -->

    <!-- 用户列表 -->
    <div class="div-inline">
      <a-table
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :columns="columns"
        :dataSource="users"
        :rowKey="(record) => record.id"
        :loading="loading"
        :scroll="{ x: 1350, y: 600 }"
      >

      <template slot="showType" slot-scope="text, record" ellipsis="...">
        <span>{{getType(text)}}</span>
      </template>

      <template slot="showMaterial" slot-scope="text, record" ellipsis="...">
        <span :title="getMaterial(record)">{{getMaterial(record)}}</span>
      </template>

        <template slot="operation" slot-scope="text, record">
          <a @click="resetUserPwd(record.id)" href="javascript:;">重置密码</a> |
          <a @click="showUser(record)" href="javascript:;">编辑</a> |
          <a @click="delUser(record.id)" href="javascript:;">删除</a> |
          <a @click="userPermission(record.id)" href="javascript:;">权限管理</a>
          |
          <a @click="deptMove(record)" href="javascript:;">部门调度</a>
        </template>
      </a-table>
    </div>
    <!-- 用户列表 -->
    <!-- 列表表格 -->

    <!-- 新增/编辑 -->
    <a-modal
      centered
      title="编辑用户"
      v-model="edit_visible"
      :zIndex="2"
      width="720px"
      :maskClosable="false"
      @ok="save_handle"
    >
      <a-form class="modal-form" :form="form">
        <a-form-item
          label="所属部门"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input
            placeholder
            :rows="4"
            v-decorator="['dept_name', { initialValue: selectedDeptName }]"
            read-only
          />
          <a-input
            type="hidden"
            v-decorator="[
              'dept_id',
              { initialValue: selectedDeptId == -1 ? 0 : selectedDeptId },
            ]"
          />
        </a-form-item>
        <a-form-item
          label="供应商名称"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input
            placeholder="请输入供应商名称"
            :rows="4"
            v-decorator="[
              'fullUnitName',
              {
                initialValue: user && user.fullUnitName,
                rules: [{ required: true, message: '供应商名称不能为空' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          label="姓名"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input
            placeholder="请输入姓名"
            :rows="4"
            v-decorator="[
              'cname',
              {
                initialValue: user && user.cname,
                rules: [{ required: true, message: '姓名不能为空' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          label="用户名"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input
            placeholder="请输入用户名称"
            :rows="4"
            v-decorator="[
              'name',
              {
                initialValue: user && user.name,
                rules: [{ required: true, message: '用户名称不能为空' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          label="密码"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
          v-if="!user"
        >
          <a-input
            placeholder="请输入密码"
            :rows="4"
            v-decorator="[
              'pwd',
              { rules: [{ required: true, message: '密码不能为空' }] },
            ]"
          />
        </a-form-item>

        <a-form-item
          label="供应商类型"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
          v-if="user"
        >
          <a-select placeholder="供应商类型" v-decorator="[
            'type',
            {
              initialValue: user && user.type
            },
          ]">
            <a-select-option v-for="o in types" :value="o.id" :key="o.id">{{ o.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="物料名称"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
          v-if="user"
        >
          <a-select placeholder="物料名称" mode="multiple" v-decorator="[
            'extMaterialName',
            {
              initialValue: user && user.extMaterialName
            },
          ]">
            <a-select-option v-for="o in gys_materials" :value="o" :key="o">{{ o }}</a-select-option>
          </a-select>
        </a-form-item>
        
        <!-- <a-form-item label="重复密码" :label-col="{ span: 5 }" :wrapper-col="{ span: 15}">
          <a-input
            placeholder="请再次输入密码"
            :rows="4"
            v-decorator="['repwd',{rules: [{ required: true, message: '密码不能为空' }]}]"
          />
        </a-form-item>-->
      </a-form>
    </a-modal>
    <!-- 新增/编辑 -->

    <a-drawer
      title="权限管理"
      :width="720"
      @close="onClose"
      :visible="permission_visible"
      :v-if="permission_visible"
      :wrapStyle="{
        height: 'calc(100% - 108px)',
        overflow: 'auto',
        paddingBottom: '108px',
      }"
    >
      <div>
        <a-card size="small" title="工作票权限" style="width: 100%">
          <div>
            <div :style="{ borderBottom: '1px solid #E9E9E9' }">
              <a-checkbox
                :indeterminate="indeterminate1"
                @change="onCheckAllChange1"
                :checked="checkAll1"
                >全选</a-checkbox
              >
            </div>
            <br />
            <a-checkbox-group
              :options="plainOptions"
              v-model="checkedList1"
              @change="onChange1"
            />
          </div>
          <br />可查看部门：
          <br />
          <a-tree-select
            style="width: 90%"
            :treeData="depts"
            :value="value1"
            @change="onChangeDept1"
            treeCheckable
            searchPlaceholder="Please select"
            :treeDefaultExpandAll="true"
          />
        </a-card>
        <br />
        <a-card size="small" title="部门权限" style="width: 100%">
          <div>
            <div :style="{ borderBottom: '1px solid #E9E9E9' }">
              <a-checkbox
                :indeterminate="indeterminate2"
                @change="onCheckAllChange2"
                :checked="checkAll2"
                >全选</a-checkbox
              >
            </div>
            <br />
            <a-checkbox-group
              :options="plainOptions"
              v-model="checkedList2"
              @change="onChange2"
            />
          </div>
          <!-- <br />部门：
          <a-tree-select
            style="width: 90%"
            :treeData="depts"
            :value="value2"
            @change="onChangeDept2"
            treeCheckable
            searchPlaceholder="Please select"
            :treeDefaultExpandAll="true"
          />-->
        </a-card>
        <br />
        <a-card size="small" title="人员权限" style="width: 100%">
          <div>
            <div :style="{ borderBottom: '1px solid #E9E9E9' }">
              <a-checkbox
                :indeterminate="indeterminate3"
                @change="onCheckAllChange3"
                :checked="checkAll3"
                >全选</a-checkbox
              >
            </div>
            <br />
            <a-checkbox-group
              :options="plainOptions"
              v-model="checkedList3"
              @change="onChange3"
            />
          </div>
          <!-- <br />部门：
          <a-tree-select
            style="width: 90%"
            :treeData="depts"
            :value="value3"
            @change="onChangeDept3"
            treeCheckable
            searchPlaceholder="Please select"
            :treeDefaultExpandAll="true"
          />-->
        </a-card>
        <!-- TODO 这里需要实现菜单的功能，采用tree的方式实现 -->
        <!-- <br />
        <a-card size="small" title="菜单权限" style="width: 100%">
          <a-tree-select
            style="width: 90%"
            :treeData="depts"
            :value="value3"
            @change="onChangeDept3"
            treeCheckable
            searchPlaceholder="Please select"
            :treeDefaultExpandAll="true"
          />
        </a-card>-->
      </div>

      <div
        :style="{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="onClose"
          >取消</a-button
        >
        <a-button @click="onPermissionSave" type="primary">保存</a-button>
      </div>
    </a-drawer>
    <!-- 权限 -->

    <!-- 部门树 -->
    <a-modal
      centered
      :title="changeDeptTitle"
      v-if="change_visible"
      v-model="change_visible"
      :zIndex="2"
      width="720px"
      :maskClosable="false"
      @ok="change_handle"
      style="top: 5px; height: 800px"
    >
      <div style="height: 700px; overflow-y: scroll">
        <a-directory-tree
          v-if="depts.length > 0 && change_visible"
          :treeData="depts"
          @select="selectTargetDeptId"
          :defaultExpandAll="true"
          :defaultExpandedKeys="[1]"
        />
      </div>
    </a-modal>
    <!-- 部门树 -->
  </a-layout-content>
</template>
<script>
import SubTitle from "@/components/common/subTitle";
import { Divider, Modal } from "ant-design-vue";
import { getUserInfo,types,gys_materials } from "@/plugins/common";
import {
  userListByDeptId,
  delUser,
  addUser,
  updUser,
  resetPwd,
  deptList,
  user_permission_list,
  user_permission_add,
  userChangeDept,
} from "@/api";

export default {
  components: {
    SubTitle,
    ADivider: Divider,
    Modal,
  },
  data() {
    return {
      types,
      gys_materials,
      // 显示列
      columns: [
        {
          title: "姓名",
          width: 100,
          dataIndex: "cname",
          key: "cname",
        },
        {
          title: "供应商",
          width: 200,
          dataIndex: "fullUnitName",
          key: "fullUnitName",
        },
        {
          title: "用户名",
          width: 150,
          dataIndex: "name",
          key: "name",
        },
        // {
        //   title: "所属部门",
        //   width: 200,
        //   dataIndex: "dept_name",
        //   key: "dept_name",
        // },
        {
          title: "类型",
          width: 70,
          dataIndex: "type",
          key: "type",
          scopedSlots: { customRender: "showType" },
        },
        {
          title: "物料",
          width: 170,
          dataIndex: "userExts",
          key: "userExts",
          scopedSlots: { customRender: "showMaterial" },
        },
        // {
        //   title: "创建时间",
        //   dataIndex: "created_at",
        //   key: "created_at",
        // },
        {
          title: "操作",
          key: "operation",
          // fixed: "right",
          width: 350,
          scopedSlots: { customRender: "operation" },
        },
      ],
      // 用户集合
      users: [],
      parentUsers: {},
      loading: false,
      deling: false,
      edit_visible: false,
      permission_visible: false,
      user: {},
      form: this.$form.createForm(this),
      selectedRowKeys: [],
      depts: [],
      selectedDeptId: -1,
      selectedDeptName: "",

      checkedList1: [],
      checkedList2: [],
      checkedList3: [],
      indeterminate1: false,
      indeterminate2: false,
      indeterminate3: false,
      checkAll1: false,
      checkAll2: false,
      checkAll3: false,
      plainOptions: ["新增", "作废", "修改", "查询", "终结", "计划", "初审"],
      userId: "",
      selectedKeys: [],
      value1: [],
      value2: [],
      value3: [],
      change_visible: false,
      targetDeptId: "",
      targetUserId: "",
      changeDeptTitle: "部门调度",
      user: {},

      keyword:""
    };
  },
  mounted() {
    this.user = getUserInfo();
    this.getDeptList();
  },
  methods: {
    // 部门数据
    getDeptList() {
      deptList()
        .then((res) => {
          let parent_id = 0;
          if (this.user.id == 9707) {
            parent_id = 62;
          }
          this.depts = this.findChildren(res, parent_id);
          this.selectedDeptName = this.depts[0].title;
          // console.log(JSON.stringify(this.depts));
        })
        .finally((res) => {
          this.loading = false;
        });
    },
    // 处理部门数据，组成树结构
    findChildren(allDepts, current_pid) {
      let tmpdepts = [];
      allDepts.forEach((item, index) => {
        if (item.parent_id == current_pid) {
          let children = this.findChildren(allDepts, item.id);
          if (children) {
            item.children = children;
          } else {
            delete item.children;
          }
          tmpdepts.push({
            key: "" + item.id,
            value: "" + item.id,
            title: item.name,
            children: item.children,
            parent_id: "" + item.parent_id,
            isLeaf: item.children ? false : true,
          });
        }
      });
      if (tmpdepts.length == 0) {
        return null;
      }
      return tmpdepts;
    },
    // 选择部门树中的节点，修改选中的title并加载选中部门下的人员数据
    onSelect(selectedKeys, info) {
      // console.log("selected", selectedKeys, info);
      this.selectedDeptId = selectedKeys[0];
      this.selectedDeptName = info.node.title;
      this.getUserListByDeptId();
    },
    getUserListByDeptId() {
      userListByDeptId(this.selectedDeptId,this.keyword||'')
        .then((res) => {
          this.users = res;
        })
        .finally((res) => {
          this.loading = false;
        });
    },
    // 新增/编辑用户
    showUser(user) {
      // console.log(user);
      if( user ) {
        try {
          let tmpUser = JSON.parse(JSON.stringify(user));
          
          let exts = user.userExts;
          if( exts ){
            tmpUser["extMaterialName"] = [];
            for( var i = 0;i < exts.length; i ++ ) {
              tmpUser["extMaterialName"].push(exts[i].materialName);
            }
          }

          this.user = tmpUser;
        } catch(e) {
          console.log(e);
        }
      } else {
        this.user = user;
      }
      this.form.resetFields();
      
      this.edit_visible = true;
    },
    // 删除用户提示
    delUserByIds() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.error("请选择您要删除的数据！");
        return;
      }
      this.delUser(this.selectedRowKeys.join(","));
    },
    // 删除用户
    delUser(ids) {
      // console.log(ids);
      var self = this;
      Modal.confirm({
        title: "提示",
        content: "确定要删除吗？",
        centered: true,
        onOk() {
          if (self.deling) return;
          self.deling = true;
          delUser(ids)
            .then((res) => {
              self.selectedRowKeys = [];
              self.$message.success("删除成功");
              self.getUserListByDeptId();
            })
            .finally((res) => {
              self.deling = false;
            });
        },
      });
    },
    // 重置密码
    resetUserPwd(id) {
      var self = this;
      Modal.confirm({
        title: "提示",
        content: "确定要重置密码吗？",
        centered: true,
        onOk() {
          if (self.deling) return;
          self.deling = true;
          resetPwd(id)
            .then((res) => {
              self.selectedRowKeys = [];
              self.$message.success("操作成功");
              self.getUserListByDeptId();
            })
            .finally((res) => {
              self.deling = false;
            });
        },
      });
    },
    // 保存用户
    save_handle() {
      this.form.validateFields((err, values) => {
        // console.log(values);
        if (!err) {
          let params = {
            cname: values.cname,
            name: values.name,
            dept_id: values.dept_id,
            pwd: values.pwd,
            type: values.type,
            extMaterialName : values.extMaterialName
          };
          if (this.user && this.user.id) {
            delete params.name;
            updUser(this.user.id, params).then((res) => {
              this.$message.success("修改成功！");
              this.getUserListByDeptId();
              this.edit_visible = false;
            });
          } else {
            // add
            addUser(params).then((res) => {
              this.$message.success("添加成功！");
              this.getUserListByDeptId();
              this.edit_visible = false;
            });
          }
        }
      });
    },
    // 获取用户权限
    userPermission(userid) {
      this.userId = userid;
      let self = this;
      user_permission_list(userid)
        .then((res) => {
          console.log(res);
          this.resetPermission();
          if (res && res.length > 0) {
            res.forEach((item, index) => {
              // console.log(item);
              if (item.source_id == 1) {
                self.fillCheckedList(self.checkedList1, item, self.value1);
                self.indeterminate1 = this.getIndeterminate(self.checkedList1);
              } else if (item.source_id == 2) {
                self.fillCheckedList(self.checkedList2, item, self.value2);
                self.indeterminate2 = this.getIndeterminate(self.checkedList2);
              } else if (item.source_id == 3) {
                self.fillCheckedList(self.checkedList3, item, self.value3);
                self.indeterminate3 = this.getIndeterminate(self.checkedList3);
              }
            });
          }
          this.permission_visible = true;
        })
        .finally((res) => {
          // console.log(self.value1);
          // console.log(self.value2);
          // console.log(self.value3);
        });
    },
    // 重置页面用户权限数据
    resetPermission() {
      let self = this;
      self.value1 = [];
      self.value2 = [];
      self.value3 = [];
      self.checkedList1 = [];
      self.checkedList2 = [];
      self.checkedList3 = [];
      self.checkAll1 = false;
      self.checkAll2 = false;
      self.checkAll3 = false;
    },
    // 获取checkbox组半选中状态
    getIndeterminate(checkdList) {
      if (
        checkdList.length > 0 &&
        checkdList.length < this.plainOptions.length
      ) {
        return true;
      } else {
        return false;
      }
    },
    // 权限名及值相互转换
    fillCheckedList(checkdList, item, value) {
      if (item.p_add == 1) {
        checkdList.push("新增");
      }
      if (item.p_delete == 1) {
        checkdList.push("作废");
      }
      if (item.p_select == 1) {
        checkdList.push("查询");
      }
      if (item.p_update == 1) {
        checkdList.push("修改");
      }
      if (item.p_audit == 1) {
        checkdList.push("终结");
      }
      if (item.p_plan == 1) {
        checkdList.push("计划");
      }
      if (item.p_precheck == 1) {
        checkdList.push("初审");
      }
      console.log(item);
      if (item.dept_ids) {
        item.dept_ids.split(",").forEach((deptId, i) => {
          console.log(deptId);
          value.push("" + deptId);
        });
      }
    },
    // 关闭权限设置页面
    onClose() {
      this.permission_visible = false;
    },
    // 用户列表checkbox选择事件
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    // 权限
    // 权限选中事件
    onChange1(checkedList) {
      this.indeterminate1 =
        !!checkedList.length && checkedList.length < this.plainOptions.length;
      this.checkAll1 = checkedList.length === this.plainOptions.length;
    },
    // 权限全选事件
    onCheckAllChange1(e) {
      Object.assign(this, {
        checkedList1: e.target.checked ? this.plainOptions : [],
        indeterminate1: false,
        checkAll1: e.target.checked,
      });
    },
    // 权限选中事件
    onChange2(checkedList) {
      this.indeterminate2 =
        !!checkedList.length && checkedList.length < this.plainOptions.length;
      this.checkAll2 = checkedList.length === this.plainOptions.length;
    },
    // 权限全选事件
    onCheckAllChange2(e) {
      Object.assign(this, {
        checkedList2: e.target.checked ? this.plainOptions : [],
        indeterminate2: false,
        checkAll2: e.target.checked,
      });
    },
    // 权限选中事件
    onChange3(checkedList) {
      this.indeterminate3 =
        !!checkedList.length && checkedList.length < this.plainOptions.length;
      this.checkAll3 = checkedList.length === this.plainOptions.length;
    },
    // 权限全选事件
    onCheckAllChange3(e) {
      Object.assign(this, {
        checkedList3: e.target.checked ? this.plainOptions : [],
        indeterminate3: false,
        checkAll3: e.target.checked,
      });
    },
    // 权限设置
    onPermissionSave() {
      let param = [];
      param.push(this.buildParam(this.checkedList1, 1, this.value1));
      param.push(this.buildParam(this.checkedList2, 2, this.value2));
      param.push(this.buildParam(this.checkedList3, 3, this.value3));

      // console.log(param);

      user_permission_add(param)
        .then((res) => {
          this.permission_visible = false;
          this.$message.success("权限设置成功！");
        })
        .finally((res) => {});
    },
    // 构建权限保存参数
    buildParam(checkdList, sourceId, value) {
      return {
        user_id: this.userId,
        source_id: sourceId,
        p_add: checkdList.indexOf("新增") == -1 ? 0 : 1,
        p_delete: checkdList.indexOf("作废") == -1 ? 0 : 1,
        p_update: checkdList.indexOf("修改") == -1 ? 0 : 1,
        p_select: checkdList.indexOf("查询") == -1 ? 0 : 1,
        p_audit: checkdList.indexOf("终结") == -1 ? 0 : 1,
        p_plan: checkdList.indexOf("计划") == -1 ? 0 : 1,
        p_precheck: checkdList.indexOf("初审") == -1 ? 0 : 1,
        dept_ids: value.join(","),
      };
    },
    // 权限部门选择
    onChangeDept1(value) {
      console.log("onChange ", value);
      this.value1 = value;
    },
    // 权限部门选择
    onChangeDept2(value) {
      console.log("onChange ", value);
      this.value2 = value;
    },
    // 权限部门选择
    onChangeDept3(value) {
      console.log("onChange ", value);
      this.value3 = value;
    },
    deptMove(user) {
      console.log("show dept list modal...");
      this.user = user;
      this.targetUserId = user.id;
      this.changeDeptTitle =
        "部门调度（" + this.user.cname + ":" + this.user.dept_name + "=>）";
      this.change_visible = true;
    },
    change_handle() {
      userChangeDept(this.targetUserId, this.targetDeptId)
        .then((res) => {
          this.permission_visible = false;
          this.$message.success("部门调度成功！");
          this.getUserListByDeptId();
          this.change_visible = false;
        })
        .finally((res) => {});
    },
    selectTargetDeptId(selectedKeys, info) {
      // console.log("selected", selectedKeys, info);
      this.targetDeptId = selectedKeys[0];
      this.changeDeptTitle =
        "部门调度（" +
        this.user.cname +
        ":" +
        this.user.dept_name +
        "=>" +
        info.node.title +
        "）";
      // this.selectedDeptName = info.node.title;
      // this.getUserListByDeptId();
    },

    getType(type) {
      for(let i = 0;i < types.length;i ++) {
        if( type == types[i].id ) {
          return types[i].name;
        }
      }
      return type;
    },

    getMaterial(record) {
      try {
        let exts = record.userExts;
        let material = [];
        if( exts ) {
          exts.forEach(function(item,idx){
            material.push(item.materialName);
          });
        }
        return material.join(",");
      }catch(e){
        console.log(e);
      }
      return "";
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/style.scss";
.other-filter {
  display: flex;
  height: 50px;
  align-items: center;
  .mr-20 {
    margin-right: 20px;
  }
}
.div-inline {
  display: table-cell;
}
</style>

